import { isError403 } from 'frontend-container/components/Errors/Error403';
import { isError404 } from 'frontend-container/components/Errors/Error404';
import { isError503 } from 'frontend-container/components/Errors/Error503';

export const isErrorPage = (
  pathname: string = window.location.pathname
): boolean =>
  isError404(pathname) || isError403(pathname) || isError503(pathname);
